import { forwardRef,  useRef } from "react";
import Heading from "../heading/heading";
import { useLocation } from "react-router-dom";

const SlideOver = (props, ref) => {
  const slideref = useRef(null);
  
  const { pathname } = useLocation();



  function closeModal() {
    if (!slideref.current.children[0].classList.contains('hidden')) {
      slideref.current.children[0].classList.add('hidden')
      if(props.setSlideData){
        props.setSlideData([]);
      }
      if(props.setMileStoneData){
        props.setMileStoneData([]);
      }
    }
  }

  return (
    <div className="slideover-main" ref={slideref}>
      <div
        className={`slideover  slideover_bg ${props.isJourneyMapPage && 'journey-map-slideover-main'} ${!props.isJourneyMapPage && props?.customCls} ${!props.isJourneyMapPage && props?.eleid}`}
        ref={ref}
      >
        <div className={`flex slideover-container w-full md:w-3/5 ${props.isNotFoundPage && '!w-[30%]'} ${props.isJourneyMapPage && 'journey-page-slideover'}`}>
          <div className={`flex slideover-outer `}>
            <div className={`slide-header ${props.isNotFoundPage && "slide-header-not-found"}`}>
              {/* {(!props.isJourneyMapPage && !pathname.includes('carrerlattice')) && <Heading type={"h2"} text={"L4 - Senior Production Specialist"} />} */}
              {(!props.isJourneyMapPage && !props.isCareerLatticePage && !props.isNotFoundPage) && <Heading type={"h2"} text={"L4 - Senior Production Specialist"} />}
              { <Heading type={"h2"} text={props.head} />}
              {!props.isJourneyMapPage && <button onClick={closeModal}>
                <svg xmlns="http://www.w3.org/2000/svg" width="12.824" height="12.824" fill="#ff0f0f" stroke="#fff" strokeWidth="0.7px" viewBox="0 0 12.824 12.824">
                  <path data-name="Icon material-outline-close" d="M19.334 8.692 18.143 7.5l-4.725 4.725L8.692 7.5 7.5 8.692l4.725 4.725L7.5 18.143l1.192 1.192 4.725-4.725 4.725 4.725 1.192-1.192-4.725-4.725z" transform="translate(-7.005 -7.005)" />
                </svg>
              </button>}
            </div>
            {props.isJourneyMapPage ? props.children : props.data}
          </div>
        </div>
      </div>
    </div>
  );
};

export default forwardRef(SlideOver);
